<template>
  <ChatItem class="chat__image" :first="first" :last="last">
    <Image :source="content.image" />
  </ChatItem>
</template>

<script>
import { Image } from '@/components/global'
import { ContentPropMixin } from '@/mixins'

import ChatItem from './ChatItem.vue'
import ChatItemPropsMixins from './ChatItemPropsMixins.js'

export default {
  name: 'ChatImage',
  mixins: [ChatItemPropsMixins, ContentPropMixin],
  components: { ChatItem, Image },
}
</script>
